module.exports = "<app-holiday-type-list></app-holiday-type-list>"